import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "bonusomat-quest-card__image-wrapper" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "bonusomat-quest-card__info" }
const _hoisted_4 = {
  key: 0,
  class: "bonusomat-quest-card__info-item"
}
const _hoisted_5 = {
  key: 1,
  class: "bonusomat-quest-card__info-item"
}
const _hoisted_6 = {
  key: 2,
  class: "bonusomat-quest-card__info-item"
}
const _hoisted_7 = { class: "bonusomat-quest-card__info-item" }
const _hoisted_8 = { class: "bonusomat-quest-card__footer" }
const _hoisted_9 = { class: "bonusomat-quest-card__footer-info bonusomat-quest-card__footer-info--active" }
const _hoisted_10 = { class: "bonusomat-quest-card__footer-texts" }
const _hoisted_11 = { class: "bonusomat-quest-card__footer-actions" }
const _hoisted_12 = { class: "bonusomat-quest-card__footer-info bonusomat-quest-card__footer-info--green" }
const _hoisted_13 = { class: "bonusomat-quest-card__footer-actions" }
const _hoisted_14 = { class: "bonusomat-quest-card__footer-info bonusomat-quest-card__footer-info--yellow" }
const _hoisted_15 = { class: "bonusomat-quest-card__award-text-wrap" }
const _hoisted_16 = { class: "bonusomat-quest-card__award-text" }
const _hoisted_17 = { class: "bonusomat-quest-card__footer-actions" }

import { computed, toRef } from "vue";

import DsBadge from "@sazka/design-system/src/badge/ds-badge.vue";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import DsIcon from "@sazka/design-system/src/icon/ds-icon.vue";
import DsButton from "@sazka/design-system/src/button/ds-button.vue";
import { BonusomatDatalayer } from "@/casino/bonusomat/utils/analytics/bonusomat-datalayer";
import BonusomatProgress from "../shared/bonusomat-progress.vue";
import BonusomatQuestAwardIcon from "./bonusomat-quest-award-icon.vue";

import useBonusomatData from "../../composables/use-bonusomat-data";
import { useQuestDetails } from "../../composables/use-quest-details";

import { BonusomatQuest } from "../../models/bonusomat-quest";
import { BonusomatLogoutQuest } from "../../models/bonusomat-logout-quest";
import { useLoyaltyPlayerStatus } from "@/loyalty/composables/use-loyalty-player-status";


export default /*@__PURE__*/_defineComponent({
  __name: 'bonusomat-quest-card',
  props: {
    quest: {},
    progressLoadCounter: {},
    actionsDisabled: { type: Boolean },
    isOnLogoutPage: { type: Boolean },
    useCalculatedTitleHeight: { type: Boolean }
  },
  emits: ["detailClicked"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const questRef = toRef(props, "quest");

const { bonusomatPlayerStatus } = useLoyaltyPlayerStatus();
const { bonusomatPlayerData, remainingSpinsCount } = bonusomatPlayerStatus;

const { openQuestDetail, activateQuest, deactivateQuest } = useBonusomatData();
const { isActive, isCompleted, isPlayable, tasksCountLabel, completedTasksLabel, questTimeLabel, questProgress } =
    useQuestDetails(questRef, props.isOnLogoutPage);

const actionsEnabled = computed(() => !props.actionsDisabled);

const completedTasks = computed(() => {
    const totalTasks = props.quest.totalTasks;

    switch (totalTasks) {
        case 1:
            return `${props.quest.completedTasks} z ${totalTasks} úkolu`;
        case 2:
        case 3:
        case 4:
            return `${props.quest.completedTasks} ze ${totalTasks} úkolů`;
        default:
            return `${props.quest.completedTasks} z ${totalTasks} úkolů`;
    }
});

const hasTasksAndIsDone = computed(
    () =>
        isActive.value ||
        (props.quest.totalTasks > 0 &&
            (props.quest.completedTasks === 0 || props.quest.completedTasks === props.quest.totalTasks))
);

const hasTasksAndIsInProgress = computed(
    () =>
        !isActive.value &&
        props.quest.totalTasks > 0 &&
        props.quest.completedTasks > 0 &&
        props.quest.completedTasks < props.quest.totalTasks
);

const activateQuestClick = (questId: number, questName: string) => {
    activateQuest(questId);
    BonusomatDatalayer.pushStartQuest(
        questName,
        "hryLobby",
        bonusomatPlayerData.value.points,
        remainingSpinsCount.value
    );
};

const openQuestDetailClick = (
    actionsEnabled: boolean,
    questId: number,
    questName: string,
    clickSource: string,
    event?: Event
) => {
    // In Safari even the click.stop event on disabled button is still propagated to parent card element => ignore these clicks
    if ((event?.target as HTMLElement)?.className == "button__inner") {
        return;
    }

    emit("detailClicked");

    if (actionsEnabled) {
        openQuestDetail(questId);
        BonusomatDatalayer.pushOpenQuest(
            questName,
            clickSource,
            bonusomatPlayerData.value.points,
            remainingSpinsCount.value
        );
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["bonusomat-quest-card", { 'bonusomat-quest-card--active': _unref(isActive) }]),
    onClick: _cache[5] || (_cache[5] = ($event: any) => (openQuestDetailClick(actionsEnabled.value, _ctx.quest.id, _ctx.quest.title, 'questDetail', $event)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.quest.badge)
        ? (_openBlock(), _createBlock(DsBadge, {
            key: 0,
            text: _ctx.quest.badge,
            class: "bonusomat-quest-card__badge"
          }, null, 8, ["text"]))
        : _createCommentVNode("", true),
      _createVNode(WebpImage, {
        "css-class": "bonusomat-quest-card__image",
        src: _ctx.quest.image,
        alt: ""
      }, null, 8, ["src"])
    ]),
    _createElementVNode("h3", {
      class: _normalizeClass(["bonusomat-quest-card__title", { 'bonusomat-quest-card__title--calculated-height': _ctx.useCalculatedTitleHeight }]),
      innerHTML: _ctx.quest.title
    }, null, 10, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      (_unref(isActive))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(BonusomatQuestAwardIcon, {
              "icon-name": _ctx.quest.awardIcon
            }, null, 8, ["icon-name"]),
            _createTextVNode(" " + _toDisplayString(_ctx.quest.award), 1)
          ]))
        : _createCommentVNode("", true),
      (hasTasksAndIsDone.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(DsIcon, {
              name: "bet-list",
              width: 16,
              height: 16
            }),
            _createTextVNode(" " + _toDisplayString(_unref(tasksCountLabel)), 1)
          ]))
        : _createCommentVNode("", true),
      (hasTasksAndIsInProgress.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(), _createBlock(BonusomatProgress, {
              key: _ctx.progressLoadCounter,
              progress: _unref(questProgress)
            }, null, 8, ["progress"])),
            _createTextVNode(" " + _toDisplayString(_unref(completedTasksLabel)), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(DsIcon, {
          name: "time",
          width: 16,
          height: 16
        }),
        _createTextVNode(" " + _toDisplayString(_unref(questTimeLabel)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_unref(isActive))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(), _createBlock(BonusomatProgress, {
                key: _ctx.progressLoadCounter,
                progress: _unref(questProgress),
                "show-percentage-number": ""
              }, null, 8, ["progress"])),
              _createElementVNode("div", _hoisted_10, [
                _cache[6] || (_cache[6] = _createElementVNode("span", null, "Splněno", -1)),
                _createElementVNode("strong", null, _toDisplayString(completedTasks.value), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(DsButton, {
                theme: "dark",
                size: "sm",
                type: "interaction",
                "icon-left": "bet-list",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (actionsEnabled.value && _unref(openQuestDetail)(_ctx.quest.id)))
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createElementVNode("span", { class: "bonusomat-quest-card__show-tasks-text" }, "Zobrazit", -1),
                  _createTextVNode(" Úkoly ")
                ])),
                _: 1,
                __: [7]
              }),
              _createVNode(DsButton, {
                theme: "light",
                size: "sm",
                type: "error",
                "icon-left": "cross",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (actionsEnabled.value && _unref(deactivateQuest)('small')), ["stop"]))
              })
            ])
          ], 64))
        : (_unref(isCompleted))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(BonusomatProgress, {
                  progress: 100,
                  "is-completed": ""
                }),
                _cache[8] || (_cache[8] = _createTextVNode(" Splněno "))
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(DsButton, {
                  theme: "dark",
                  size: "sm",
                  type: "interaction",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (openQuestDetailClick(actionsEnabled.value, _ctx.quest.id, _ctx.quest.title, 'detailButton')), ["stop"]))
                }, {
                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                    _createTextVNode("Detail")
                  ])),
                  _: 1,
                  __: [9]
                })
              ])
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(BonusomatQuestAwardIcon, {
                  "icon-name": _ctx.quest.awardIcon
                }, null, 8, ["icon-name"]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.quest.award), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(DsButton, {
                  theme: "dark",
                  size: "sm",
                  type: "interaction",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (openQuestDetailClick(actionsEnabled.value, _ctx.quest.id, _ctx.quest.title, 'detailButton')), ["stop"]))
                }, {
                  default: _withCtx(() => _cache[10] || (_cache[10] = [
                    _createTextVNode("Detail")
                  ])),
                  _: 1,
                  __: [10]
                }),
                _createVNode(DsButton, {
                  theme: "dark",
                  size: "sm",
                  "is-disabled": _ctx.isOnLogoutPage || !_unref(isPlayable),
                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (actionsEnabled.value && activateQuestClick(_ctx.quest.id, _ctx.quest.title)), ["stop"]))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.quest.totalTasks > 0 ? "Hrát" : "Získat bonus"), 1)
                  ]),
                  _: 1
                }, 8, ["is-disabled"])
              ])
            ], 64))
    ])
  ], 2))
}
}

})